import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../shared/common';
import {
  LoadingIndicatorModule
} from '../shared/layout/components/loading-indicator/loading-indicator.module';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb';
import {GridModule} from '@progress/kendo-angular-grid';
import {ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {MatCardModule, MatDialogModule, MatExpansionPanel, MatIconModule} from '@angular/material';
import {FlexLayoutModule} from '@angular/flex-layout';
import { UploadModule } from '@progress/kendo-angular-upload';
import {TitleCasePipe} from '@angular/common';
import {LiveSessionComponent} from './live-session.component';
import {FileViewerDialogComponent} from './components/file-viewer-dialog.component';
import {PrescriptionDialogComponent} from './components/prescription-dialog.component';
import {ImageViewerDialogComponent} from './components/image-viewer-dialog.component';
import {DeferredSessionComponent} from './deferred-session.component';
import {SchedulerModule} from '@progress/kendo-angular-scheduler';
import {ProgressBarModule} from '@progress/kendo-angular-progressbar';
import {NoteDialogComponent} from '../clients/components/note-dialog.component';
import {MatExpansionModule} from '@angular/material/expansion';

@NgModule({
  declarations: [
    DeferredSessionComponent
  ],
  imports: [
    ButtonsModule,
    ProgressBarModule,
    DateInputsModule,
    GridModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule,
    MatExpansionModule,
    ReactiveFormsModule,
    DialogModule,
    UploadModule,
    MatDialogModule,
    MatCardModule,
    MatIconModule,
    SchedulerModule,
    FlexLayoutModule,
  ],
  exports: [
  ],
  providers: [
    TitleCasePipe
  ],
  entryComponents: [
    FileViewerDialogComponent,
    PrescriptionDialogComponent,
    ImageViewerDialogComponent,
    NoteDialogComponent
  ],
})
export class DeferredSessionModule {
}
